import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Property } from 'csstype';

const CustomLoader = ({ size }: { size: Property.FontSize }) => {
  let fontSize;
  switch (size) {
    case 'extra-small':
      fontSize = '18px';
      break;
    case 'small':
      fontSize = '32px';
      break;
    case 'medium':
      fontSize = '48px';
      break;
    case 'large':
      fontSize = '60px';
      break;
    case 'extra-large':
      fontSize = '72px';
      break;
    default:
      fontSize = '48px';
  }

  return (
    <Spin
      indicator={
        <LoadingOutlined
          style={{
            fontSize: fontSize,
          }}
          spin
        />
      }
    />
  );
};

export default CustomLoader;
